<template>
  <v-select
    v-bind="[fieldProps, $attrs]"
    :loading="loading"
    :items="parsedItems"
    v-model="model"
    name="tipo"
    placeholder="Tipo"
    :menu-props="menuProps"
    clearable
    multiple
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item }}</span>
      </v-chip>

      <span v-if="index === 1" class="text-body-2 font-weight-regular">
        (+{{ model.length - 1 }})
      </span>
    </template>
  </v-select>
</template>

<script>
import { mixin } from "./mixin";

const _config = {
  mod: "categories",
};

const _data = {
  loading: true,
  model: null,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    menuProps() {
      const height = window.innerHeight - 200;

      return {
        maxHeight: height,
        closeOnContentClick: true,
      };
    },
    items() {
      return this.$rest(_config.mod).list;
    },
    parsedItems() {
      const filterTerrains = ["Terreno", "Terreno Comercial"];
      const filterRural = ["Área", "Chácara", "Fazenda", "Sítio"];

      switch (this.$route.path) {
        case "/imoveis":
        case "/locacao":
          return this.items.filter(
            (item) => ![...filterTerrains, ...filterRural].includes(item)
          );
        case "/terrenos":
          return filterTerrains;
        case "/rural":
          return filterRural;
        default:
          return this.items;
      }
    },
  },
  watch: {
    $route(v) {
      this.model = v.query.tipo ? v.query.tipo.split(",").map((v) => v) : null;
    },
  },
  mounted() {
    if (this.$route.query.tipo)
      this.model = this.$route.query.tipo.split(",").map((v) => v);
  },
  created() {
    this.$rest(_config.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  mixins: [mixin],
};
</script>
